var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -4 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1310_9680)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1310_9680",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1310_9680)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "#F1361D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91046 2.7688L10.8751 2.80998L11.1061 3.74739L11.4882 2.83054L12.4542 2.85411L11.7257 2.24629L12.0917 1.32344L11.2594 1.86464L10.5196 1.27072L10.7337 2.21302L9.91046 2.7688ZM11.7496 5.4382L12.6756 5.71154L12.673 6.67701L13.2655 5.87984L14.1972 6.13644L13.6374 5.37042L14.2158 4.56354L13.2773 4.88729L12.7031 4.132L12.6829 5.09811L11.7496 5.4382ZM13.3092 9.42015L12.5367 9.99922L12.8217 9.04774L12.0592 8.45414L13.0079 8.44515L13.3092 7.49922L13.6105 8.44515L14.5592 8.45414L13.7967 9.04774L14.0818 9.99922L13.3092 9.42015ZM10.1203 12.1428L11.0535 11.8953L11.5529 12.7216L11.645 11.7326L12.5744 11.4679L11.6981 11.1042L11.7731 10.1142L11.1394 10.8784L10.2564 10.5314L10.741 11.3674L10.1203 12.1428Z",
    fill: "#FFDC42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66669 8.22666L4.31555 9.90272L5.18304 7.14872L2.86246 5.43059L5.74974 5.40459L6.66669 2.66666L7.58363 5.40459L10.4709 5.43059L8.15034 7.14872L9.01783 9.90272L6.66669 8.22666Z",
    fill: "#FFDC42"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1310_9680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChina);
export default __webpack_public_path__ + "static/media/china.5f31befc7ec34c184c07a827da549cd8.svg";
export { ForwardRef as ReactComponent };